export default {
  '$schema': 'http://json-schema.org/draft-07/schema',
  '$id': 'http://example.com/example.json',
  'type': 'array',
  'title': 'The root schema',
  'additionalItems': true,
  'items': {
    '$id': '#/items',
    'type': 'object',
    'title': 'The items schema',
    'properties': {
      'order': {
        '$id': '#/items/properties/order',
        'type': 'integer',
        'title': 'The order schema'
      },
      'name': {
        '$id': '#/items/properties/name',
        'type': 'object',
        'title': 'The name schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/name/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'nz': {
            '$id': '#/items/properties/name/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'cn': {
            '$id': '#/items/properties/name/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'au': {
            '$id': '#/items/properties/name/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/name/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/name/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/name/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/name/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'slug': {
        '$id': '#/items/properties/slug',
        'type': 'object',
        'title': 'The slug schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/slug/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'nz': {
            '$id': '#/items/properties/slug/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'cn': {
            '$id': '#/items/properties/slug/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'au': {
            '$id': '#/items/properties/slug/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/slug/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/slug/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/slug/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/slug/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'navigationLabel': {
        '$id': '#/items/properties/navigationLabel',
        'type': 'object',
        'title': 'The navigationLabel schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/navigationLabel/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'nz': {
            '$id': '#/items/properties/navigationLabel/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'cn': {
            '$id': '#/items/properties/navigationLabel/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'au': {
            '$id': '#/items/properties/navigationLabel/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/navigationLabel/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/navigationLabel/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/navigationLabel/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/navigationLabel/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'sidebarLabel': {
        '$id': '#/items/properties/sidebarLabel',
        'type': 'object',
        'title': 'The sidebarLabel schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/sidebarLabel/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'nz': {
            '$id': '#/items/properties/sidebarLabel/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'cn': {
            '$id': '#/items/properties/sidebarLabel/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'au': {
            '$id': '#/items/properties/sidebarLabel/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/sidebarLabel/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/sidebarLabel/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/sidebarLabel/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/sidebarLabel/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'breadcrumbLabel': {
        '$id': '#/items/properties/breadcrumbLabel',
        'type': 'object',
        'title': 'The breadcrumbLabel schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/breadcrumbLabel/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'nz': {
            '$id': '#/items/properties/breadcrumbLabel/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'cn': {
            '$id': '#/items/properties/breadcrumbLabel/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'au': {
            '$id': '#/items/properties/breadcrumbLabel/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/breadcrumbLabel/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/breadcrumbLabel/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/breadcrumbLabel/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/breadcrumbLabel/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'pageName': {
        '$id': '#/items/properties/pageName',
        'type': 'string',
        'title': 'The pageName schema'
      },
      'onPageTitle': {
        '$id': '#/items/properties/onPageTitle',
        'type': 'object',
        'title': 'The onPageTitle schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/onPageTitle/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'nz': {
            '$id': '#/items/properties/onPageTitle/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'cn': {
            '$id': '#/items/properties/onPageTitle/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'au': {
            '$id': '#/items/properties/onPageTitle/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/onPageTitle/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/onPageTitle/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/onPageTitle/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/onPageTitle/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'onPageDescription': {
        '$id': '#/items/properties/onPageDescription',
        'type': 'object',
        'title': 'The onPageDescription schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/onPageDescription/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'cn': {
            '$id': '#/items/properties/onPageDescription/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'nz': {
            '$id': '#/items/properties/onPageDescription/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'au': {
            '$id': '#/items/properties/onPageDescription/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/onPageDescription/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/onPageDescription/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/onPageDescription/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/onPageDescription/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'metaHTMLTitle': {
        '$id': '#/items/properties/metaHTMLTitle',
        'type': 'object',
        'title': 'The metaHTMLTitle schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/metaHTMLTitle/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'nz': {
            '$id': '#/items/properties/metaHTMLTitle/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'cn': {
            '$id': '#/items/properties/metaHTMLTitle/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'au': {
            '$id': '#/items/properties/metaHTMLTitle/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/metaHTMLTitle/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/metaHTMLTitle/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/metaHTMLTitle/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/metaHTMLTitle/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'metaHTMLDescription': {
        '$id': '#/items/properties/metaHTMLDescription',
        'type': 'object',
        'title': 'The metaHTMLDescription schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/metaHTMLDescription/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'nz': {
            '$id': '#/items/properties/metaHTMLDescription/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'cn': {
            '$id': '#/items/properties/metaHTMLDescription/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'au': {
            '$id': '#/items/properties/metaHTMLDescription/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/metaHTMLDescription/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/metaHTMLDescription/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/metaHTMLDescription/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/metaHTMLDescription/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'category': {
        '$id': '#/items/properties/category',
        'type': 'boolean',
        'x-display': 'textarea',
        'title': 'The category schema'
      },
      'image': {
        '$id': '#/items/properties/image',
        'type': 'string',
        'x-display': 'textarea',
        'title': 'The image schema'
      },
      'ampTopHeaderH1': {
        '$id': '#/items/properties/ampTopHeaderH1',
        'type': 'object',
        'title': 'The ampTopHeaderH1 schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/ampTopHeaderH1/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'nz': {
            '$id': '#/items/properties/ampTopHeaderH1/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'cn': {
            '$id': '#/items/properties/ampTopHeaderH1/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'au': {
            '$id': '#/items/properties/ampTopHeaderH1/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/ampTopHeaderH1/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/ampTopHeaderH1/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/ampTopHeaderH1/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/ampTopHeaderH1/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'topHeaderH1': {
        '$id': '#/items/properties/topHeaderH1',
        'type': 'object',
        'title': 'The topHeaderH1 schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/topHeaderH1/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'nz': {
            '$id': '#/items/properties/topHeaderH1/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'cn': {
            '$id': '#/items/properties/topHeaderH1/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'au': {
            '$id': '#/items/properties/topHeaderH1/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/topHeaderH1/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/topHeaderH1/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/topHeaderH1/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/topHeaderH1/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'pageDescriptionTitle': {
        '$id': '#/items/properties/pageDescriptionTitle',
        'type': 'object',
        'title': 'The pageDescriptionTitle schema',
        'properties': {
          'en': {
            '$id': '#/items/properties/pageDescriptionTitle/properties/en',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The en schema'
          },
          'nz': {
            '$id': '#/items/properties/pageDescriptionTitle/properties/nz',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The nz schema'
          },
          'cn': {
            '$id': '#/items/properties/pageDescriptionTitle/properties/cn',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The cn schema'
          },
          'au': {
            '$id': '#/items/properties/pageDescriptionTitle/properties/au',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The au schema'
          },
          'gb': {
            '$id': '#/items/properties/pageDescriptionTitle/properties/gb',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The gb schema'
          },
          'fr': {
            '$id': '#/items/properties/pageDescriptionTitle/properties/fr',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The fr schema'
          },
          'de': {
            '$id': '#/items/properties/pageDescriptionTitle/properties/de',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The de schema'
          },
          'es': {
            '$id': '#/items/properties/pageDescriptionTitle/properties/es',
            'type': 'string',
            'x-display': 'textarea',
            'title': 'The es schema'
          }
        }
      },
      'headerBackgroundColor': {
        '$id': '#/items/properties/headerBackgroundColor',
        'type': 'string',
        'x-display': 'textarea',
        'title': 'The headerBackgroundColor schema'
      },
      'headerBackgroundColor2': {
        '$id': '#/items/properties/headerBackgroundColor2',
        'type': 'string',
        'x-display': 'textarea',
        'title': 'The headerBackgroundColor2 schema'
      },
      'headerBoxShadow': {
        '$id': '#/items/properties/headerBoxShadow',
        'type': 'string',
        'x-display': 'textarea',
        'title': 'The headerBoxShadow schema'
      }
    }
  }
}
